import dayjs from 'dayjs';
import {
  PowerOutage,
  SensorPoint,
  TemperatureBreach,
} from 'seacube-backend/src/api/client';

import { LinechartPoint, store } from './store';

export const setLinechartData = () => {
  // Création d'une série de points initialisée
  const serie: LinechartPoint[] = store.sensorData.filtered.map((x) => ({
    ...x,
    temperature_breach_id: null,
    power_outage_id: null,
  }));

  if (!store.tsFilterRange) return serie;

  const [rangeStart, rangeEnd] = store.tsFilterRange;

  // Filtrer les événements dans la plage sélectionnée
  const powerOutagesDuringLeg = store.powerOutages.filtered.filter(
    (p: PowerOutage) =>
      dayjs(p.start_datetime).valueOf() >= rangeStart ||
      dayjs(p.start_datetime).valueOf() < rangeEnd,
  );

  const temperatureBreachesDuringLeg =
    store.temperatureBreaches.filtered.filter(
      (p: TemperatureBreach) =>
        dayjs(p.start_datetime).valueOf() >= rangeStart &&
        dayjs(p.start_datetime).valueOf() < rangeEnd,
    );

  // Préparer les mappings pour un accès rapide
  const powerOutageMapping: { [index: number]: PowerOutage } = {};
  const temperatureBreachMapping: { [index: number]: TemperatureBreach } = {};

  // Remplir les mappings d'indices à partir de la série
  serie.forEach((point, index) => {
    const timestamp = dayjs(point.timestamp).valueOf();

    // Vérifier les Power Outages
    powerOutagesDuringLeg.forEach((p) => {
      const start = dayjs(p.start_datetime).valueOf();
      const end = dayjs(p.end_datetime).valueOf();
      if (timestamp >= start && timestamp <= end) {
        powerOutageMapping[index] = p; // Stocker l'index et l'événement
        point.power_outage_id = p.id;
      }
    });

    // Vérifier les Temperature Breaches
    temperatureBreachesDuringLeg.forEach((p) => {
      const start = dayjs(p.start_datetime).valueOf();
      const end = dayjs(p.end_datetime).valueOf();
      if (timestamp >= start && timestamp <= end) {
        temperatureBreachMapping[index] = p; // Stocker l'index et l'événement
      }
    });
  });

  // Mise à jour de la série avec les données des mappings
  serie.forEach((point, index) => {
    if (powerOutageMapping[index]) {
      point.power_outage_id = powerOutageMapping[index].id;
    }
    if (temperatureBreachMapping[index]) {
      point.temperature_breach_id = temperatureBreachMapping[index].id;
    }
  });

  // Mettre à jour le store avec la série mise à jour
  store.linechart.data = serie;
  store.linechart.powerOutageMapping = powerOutageMapping;
  store.linechart.temperatureBreachMapping = temperatureBreachMapping;
};
